import { GetterTree, Module } from 'vuex';

import { NavLink } from '../models/types';

export interface NavState {
  navLinks: Array<NavLink | null>;
  navLinksBottom: Array<NavLink | null>;
}

export const state: NavState = {
         navLinks: [
           {
             name: "Translate",
             icon: "home",
             path: "/translate",
             isExternal: false,
           },
           {
             name: "Translation",
             icon: "list",
             path: "/translations",
             isExternal: false,
           },
           {
             name: 'Stats',
             icon: 'domain',
             path: '/stats',
             isExternal: false
           },
           null,
           {
             name: "Text Translator",
             icon: "link",
             path: "https://cognitivehub.sgs.com/translate",
             isExternal: true,
           },
          //  {
          //    name: "Video Translator",
          //    icon: "link",
          //    path: "https://videotranslator.sgs.com",
          //    isExternal: true,
          //  },
         ],
         navLinksBottom: [
           {
             name: "Help & Feedback",
             icon: "help",
             path: "/feedback",
             isExternal: false,
           },
           {
             name: "About",
             icon: "info",
             path: "/about",
             isExternal: false,
           },
         ],
       };

export const getters: GetterTree<NavState, any> = {
  navLinks: () => state.navLinks,
  navLinksBottom: () => state.navLinksBottom
};

export const nav: Module<NavState, any> = {
  state,
  getters,
  namespaced: true
};
